module.exports = __webpack_public_path__ + "static/logo-d59111852e62a4ac06855e46ee2888e6.png";